<h3 *ngIf="!isMobileTitle" class="ds-heading--l d-none d-lg-block m-0">  {{ctaLabel | cxTranslate}}</h3>

<h3 *ngIf="isMobileTitle" class="ds-heading--xs ds-color--grey-1  m-0">  {{ctaLabel | cxTranslate}}</h3>
